import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InstanceEntity } from 'mj_generatedentities';
import { UserContextService } from 'src/app/core/services/user-context.service';
import { CellClickEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-settings-instances',
  templateUrl: './instance-list.component.html',
  styleUrls: ['./instance-list.component.css']
})
export class InstanceListComponent implements OnInit{
  public instances: InstanceEntity[] = [];
  public IsLoading: boolean = true;

  constructor(
    private userContextService: UserContextService,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    // load instances from organization service
    this.instances = await this.userContextService.GetInstancesOfOrganization();

    this.IsLoading = false;
  }

  public onCellClick(event: CellClickEvent): void {
    const selectedInstance = event.dataItem as InstanceEntity;
    this.router.navigate(['/settings/instance', selectedInstance.ID, 'details']);
  }
}
